import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { SharedService } from '../../services/shared.service';
import { Observable } from 'rxjs';
import * as moment from "moment-timezone";

@Component({
  selector: 'app-support-plans',
  templateUrl: './plans.component.html',
  styleUrls: ['./plans.component.scss']
})
export class SupportPlansComponent implements OnInit {
  plans$: Observable<any>;
  isLoaded: boolean = false;

  constructor(
    public auth: AuthService,
    private shared: SharedService
  ) {}

  ngOnInit() {
    this.plans$ = this.auth.getSupportedVtubers();
  }

  async loadPlans() {
  }

  openItem(plan) {
    this.shared.setCookie(SharedService.CURRENT_SUPPORT_PLAN, plan)
    this.shared.redirect('/user/plan/view');
  }

  formatStopAt(plan) {
    if (plan.stoppedAt) {
      return moment(plan.stoppedAt).tz('Asia/Tokyo').format("Y年MM月DD日");
    }

    if (plan.plan.delete) {
      let deleteAt = moment(plan.plan.delete.deleteAt + "-01 00:00:00").tz('Asia/Tokyo').add(-1, "d");
      return deleteAt.format("Y年MM月DD日");
    }

    return "";
  }
}
